import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getOAuthProviders, OAuthProvider } from '../../api/auth';
import { trackEvent } from '../../utils/analytics';

export const OAuthButtons: React.FC = () => {
  const { t } = useTranslation();
  const [providers, setProviders] = useState<OAuthProvider[]>([]);

  useEffect(() => {
    getOAuthProviders()
      .then(r => setProviders(r.data))
      .catch(() => {});
  }, []);

  if (providers.length === 0) return null;

  const apiBase = process.env.REACT_APP_API_URL || '/api';

  return (
    <div className="oauth-buttons">
      <div className="oauth-buttons__divider">
        <span>{t('auth.or')}</span>
      </div>
      {providers.map(p => (
        <a
          key={p.name}
          href={`${apiBase}/auth/oauth/${p.name}`}
          className="oauth-buttons__btn"
          onClick={() => trackEvent('oauth_start', { provider: p.name })}
        >
          ▶ {p.display_name}
        </a>
      ))}
    </div>
  );
};
